module.exports = __webpack_public_path__ + "static/media/RangeIcon.cebef9f9.svg";